module.exports = __webpack_public_path__ + "img/empty-bg.e6448cd3.png";